<template>
  <div class="mt-5">
    <!-- <div class="vx-row mb-5">
      <div class="vx-col w-1/1 text-center">
        <div class="datepicker-main">
            <div class="datewrapper">
                <label for class="float-right w-auto">Select Date</label>
                <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                    placeholder="Select Date"
                    class="float-right calendar-icon-right top-45"
                    :format="format"
                    v-model="current_date"
                    :disabledDates="disabledDates"
                ></datepicker>
            </div>
        </div>
      </div>
    </div> -->
    <div class="vx-row mb-5" v-if="!active_user_id && !active_user_name">
      <div :class="'vx-col w-full'">
        <vs-list  >
          <vs-list-item :title="(user.firstname+' '+user.lastname) | capitalize" :subtitle="user.designation" @click.native="getUserActivityDetails(user._id,user.firstname,user.lastname,user.department?user.department.department_name:'',user.office?user.office.office_name:'')" :key="uindex" v-for="(user,uindex) in all_users">
            <template slot="avatar">
              <vs-avatar class="" :src="user.profile_image" size="40px" v-if="user.profile_image"/>
              <vs-avatar color="primary" class="name-avatar" :text="usernameList(user.firstname,user.lastname)" size="40px" v-else />
            </template>
          </vs-list-item>
        </vs-list>
      </div>
    </div>
    <div v-else>
      <div class="flex flex-wrap items-center email-header justify-between sm:pb-2">
        <div class="flex mb-4">
          <div class="flex items-center">
            <feather-icon icon="ArrowLeftIcon" @click="clearArray()" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
            <h3 >{{ active_user_name | capitalize }}</h3>
          </div>
        </div>
        <!-- <div class="ml-10 mb-4 mt-1">
          <div class="email__actions--single flex items-baseline">
            <vue-json-to-csv :json-data="activity_data.length ? getCSVData() : []" :csv-title="active_user_name+'-activity-data'">
              <vs-button :disabled="!activity_data.length" class="gradient-btn">
                <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon> CSV
              </vs-button>
            </vue-json-to-csv>
            <vs-button
              :disabled="!activity_data.length"
              class="ml-1 gradient-btn"
              title="Download PDFs"
              @click.prevent="generatePDF"
            >
              <feather-icon icon="FileTextIcon" class></feather-icon> PDF
            </vs-button>       
          </div>
        </div> -->
      </div>
      <div class="vx-row" >
        <div class="vx-col md:w-3/5 sm:w-1/1">
          <h4 class="m-2">{{convertDate(current_date)}}</h4>
            <vs-button
              class="ml-1 gradient-btn"
              title="Edit"
              @click.prevent="openTimesheetSlidebar(active_user_id,current_date)"
            >
              Edit
            </vs-button>       
          <vs-table class="" :data="manageTimeArray(activity_data)" :disabled="true">
            <template slot="thead">
              <vs-th class="sticky-col user-col">Status</vs-th>
              <vs-th class="sticky-col user-col">Time</vs-th>
              <vs-th class="sticky-col user-col">Notes</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="sticky-col user-col">{{ manageStatus(tr.main_status,tr.status,tr.is_clockedIn,tr.is_clockedOut) }}</vs-td>
                <vs-td class="sticky-col user-col">{{ tr.start_time | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm a') }}</vs-td>
                <vs-td class="sticky-col user-col">{{ tr.comment }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col w-100 mt-8">
          <vs-table class="" :data="activity_data" :disabled="true">
            <template>
              <vs-tr>
                <vs-th>Total Time</vs-th>
                <vs-td class="sticky-col user-col center-col"></vs-td>
                <vs-td class="sticky-col user-col">{{total_active_time || '00.00' }} hrs worked</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th>Break/s</vs-th>
                <vs-td class="sticky-col user-col center-col"></vs-td>
                <vs-td class="sticky-col user-col">{{total_break_time || '00.00' }} hrs worked</vs-td>
              </vs-tr>
              <!-- <vs-tr>
                <vs-th>In</vs-th>
                <vs-td class="sticky-col user-col center-col">4.5 hrs</vs-td>
                <vs-td class="sticky-col user-col bg-success">55% IN</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th>OUT</vs-th>
                <vs-td class="sticky-col user-col center-col">4 hrs</vs-td>
                <vs-td class="sticky-col user-col bg-warning">45% OUT</vs-td>
              </vs-tr> -->
            </template>
          </vs-table>
        </div>
      </div>
        <div class="printpdf hidden" >
        <div id="printpdf">

          <table width="100%" style="width:100%;border-collapse: collapse;border:0;margin:10px 10px;">
            <tbody>
            
            </tbody>
          </table>
          <table width="100%" style="border-collapse: collapse;width:100%;margin:0px 10px 10px 10px;" id="pdfHeader">
            <tbody>
              <tr style="border-collapse: collapse;border:0;">
                  <td style="min-width:90px;max-width:90px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;">Daily Activity Log</td>
                  <td style="min-width:100px;max-width:100px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;text-align:right;">{{ $store.state.uInfo.org_name }}</td>
              </tr>
            <tr style="border-collapse: collapse;">
              <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;" colspan="2">User: <span>{{ active_user_name }}</span></td>
            </tr>
            <tr style="border-collapse: collapse;">
             <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;">Office: {{ active_user_office }} </td> 
              <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;">Department: {{ active_user_department }}</td>
            </tr >
            <tr style="border-collapse: collapse;">
              <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;" colspan="2">Date: <span>{{convertDate(current_date)}}</span></td>
            </tr>
            </tbody>
          </table>
          <table width="100%" style="width:100%;border-collapse: collapse;border:0;margin:0px 10px;" id="dailypdf">
            <thead>
              <tr style="border-collapse: collapse;border:0;">
                  <th style="letter-spacing: 0px;min-width:55px;max-width:55px;font-size:6px;border: 1px solid #abc0e4;border-right:0 !important;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">Status</th>
                  <th style="letter-spacing: 0px;min-width:45px;max-width:45px;font-size:6px;border: 1px solid #abc0e4;border-right:0 !important;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">Time</th>
                  <th style="letter-spacing: 0px;min-width:87px;max-width:87px;font-size:6px;border: 1px solid #abc0e4;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr style="border-collapse: collapse;border:0;">
                <th style="letter-spacing: 0px;padding:3px 3px;border: 1px solid #abc0e4;font-size:5px;font-weight:900;border-top:0 !important;border-bottom:0;color:#000;" colspan="3">{{ convertDatePDF(current_date) }}</th>
              </tr>
              <tr :key="indextr" v-for="(tr, indextr) in manageTimeArray(activity_data)" style="border-collapse: collapse;border:0;">
                  <th style="letter-spacing: 0px;color:#000;font-size:5px;border: 1px solid #abc0e4;border-bottom:0;border-right:0;border-collapse: collapse;padding:3px 3px;" class="sticky-col user-col">{{manageStatus(tr.main_status,tr.status,tr.is_clockedIn,tr.is_clockedOut) }}</th>
                  <td style="color:#000;font-size:5px;border: 1px solid #abc0e4;border-bottom:0;border-right:0;border-collapse: collapse;padding:3px 3px;" >{{ tr.start_time | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm A') }} </td>
                  <td style="letter-spacing: 0px;color:#000;font-size:5px;border: 1px solid #abc0e4;border-bottom:0;border-collapse: collapse;padding:3px 3px;" >{{ tr.comment }}</td>
              </tr>
              <tr style="border-collapse: collapse;border:0;">
                <th style="letter-spacing: 0px;color:#000;padding:3px 3px;border: 1px solid #abc0e4;font-size:5px;border-bottom:0;border-right:0;">Total Time</th>
                <td style="letter-spacing: 0px;color:#000;font-size:5px;padding:3px 3px;border: 1px solid #abc0e4;border-bottom:0;" colspan="2">{{total_active_time || '00.00' }} hrs worked</td>
              </tr>
              <tr style="border-collapse: collapse;border:0;">
                <th style="letter-spacing: 0px;color:#000;padding:3px 3px;border: 1px solid #abc0e4;border-right:0;font-size:5px;">Break/s</th>
                <td style="letter-spacing: 0px;color:#000;font-size:5px;padding:3px 3px;border: 1px solid #abc0e4;" colspan="2">{{total_break_time || '00.00' }} hrs worked</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- <vs-collapse type="border" class="activity-collapse" accordion>
      <vs-collapse-item :key="uindex" v-for="(user,uindex) in all_users" >
        <div slot="header" >
          <vs-list @click.native="getUserActivityDetails(user._id,user.firstname,user.lastname)">
            <vs-list-item :title="user.firstname+' '+user.lastname" :subtitle="user.designation">
              <template slot="avatar">
                <vs-avatar class="" :src="user.profile_image" size="40px" v-if="user.profile_image"/>
                <vs-avatar color="primary" class="name-avatar" :text="usernameList(user.firstname,user.lastname)" size="40px" v-else />
              </template>
            </vs-list-item>
          </vs-list>
        </div>
        <div class="vx-row w-100 m-0 justify-end mb-2">
          <vue-json-to-csv :json-data="activity_data.length ? getCSVData() : []" :csv-title="active_user_name+'-activity-data'">
            <vs-button :disabled="!activity_data.length" class="gradient-btn">
              <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon> CSV
            </vs-button>
          </vue-json-to-csv>
          <vs-button
            :disabled="!activity_data.length"
            class="ml-1 gradient-btn"
            title="Download PDFs"
            @click.prevent="generatePDF"
          >
            <feather-icon icon="FileTextIcon" class></feather-icon> PDF
          </vs-button>
        </div>
        <div class="vx-row" :id="'user-actity-'+user._id">
          <div class="vx-col w-3/5">
            <vs-table class="activity-table" :data="manageTimeArray(activity_data)" :disabled="true">
              <template slot="thead">
                <vs-th class="sticky-col user-col">Status</vs-th>
                <vs-th class="sticky-col user-col">Time</vs-th>
                <vs-th class="sticky-col user-col">Notes</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td class="sticky-col user-col">{{ manageStatus(tr.main_status,tr.status) }}</vs-td>
                  <vs-td class="sticky-col user-col">{{ tr.start_time | moment('h:mm a') }}</vs-td>
                  <vs-td class="sticky-col user-col">{{ tr.comment }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-col w-100">
            <vs-table class="activity-table" :data="activity_data" :disabled="true">
              <template>
                <vs-tr>
                  <vs-th>Total Time</vs-th>
                  <vs-td class="sticky-col user-col center-col"></vs-td>
                  <vs-td class="sticky-col user-col">{{total_active_time || '00.00' }} hrs worked</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-th>Break/s</vs-th>
                  <vs-td class="sticky-col user-col center-col"></vs-td>
                  <vs-td class="sticky-col user-col">{{total_break_time || '00.00' }} hrs worked</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-th>In</vs-th>
                  <vs-td class="sticky-col user-col center-col">4.5 hrs</vs-td>
                  <vs-td class="sticky-col user-col bg-success">55% IN</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-th>OUT</vs-th>
                  <vs-td class="sticky-col user-col center-col">4 hrs</vs-td>
                  <vs-td class="sticky-col user-col bg-warning">45% OUT</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse> -->
    
  </div>
</template>

<script>
import moment from "moment";
import { EventBus } from '@/mixins/mixin.js';
import Datepicker from "vuejs-datepicker";
import VueJsonToCsv from "vue-json-to-csv";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
export default {
  components: {
    Datepicker,
    jsPDF,
    "vue-json-to-csv": VueJsonToCsv,
    EventBus
  },
  props: {
    office_id: {
      required: false,
      default: 'all',
      type: String
    },
    department_id: {
      required: false,
      default: 'all',
      type: Array
    },
    search: {
      required: false,
      default: '',
      type: String
    },
     current_date: {
      required: true,
      default: new Date(),
    },
  },
  data() {
    return {
      timezone: this.$store.state.uInfo.timeZone,
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      all_users: [],
      active_user_id: null,
      activity_data: [],
      //current_date: new Date(),
      format: "dd/MM/yyyy",
      csvData: [],
      disabledDates: {
        from: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1
        ) // Disable all dates after specific date
      },
      total_active_time: null,
      total_break_time: null,
      active_user_name: '',
      active_user_department:'',
      active_user_office:'',
      active_first_name:'',
      active_last_name:'',
    };
  },
  watch:{
    office_id(nv) {
        this.getusers();
    },
    department_id(nv) {
     // if (nv) {
        this.getusers();
    // }
    },
    currentPage(nv) {
      if (nv) {
        this.getusers();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getusers();
      }
    },
    search(nv){
     // if (nv && nv.length > 3) {
        this.getusers();
      //}
    },
    current_date(nv) {
      if (nv) {
        this.getusers();
        if(this.active_user_id && this.active_user_name){
          this.getUserActivityDetails(this.active_user_id,this.active_first_name,this.active_last_name,this.active_user_office,this.active_user_department);
        }
      }
    },
  },
  created() {
  },
  mounted() {
    this.getusers();
      EventBus.$on("dayDailyTimeAcitivityPDF", () => {
        this.generatePDF();
      });
  },
  computed: {
  },
  methods: {
    convertDate(date){
      return moment.tz(date, this.timezone).format('DD/MM/YYYY');
    },
    convertDatePDF(date){
       return moment.tz(date, this.timezone).format('Do MMM YY');
    },
    manageTimeArray(time_arr){
      let custom_arr = [];
      time_arr.forEach(element => {
        let current = moment.tz(this.current_date, this.timezone).format('DD/MM/YYYY');
        let start_date = moment.tz(element.start_time, this.timezone).format('DD/MM/YYYY');
        if (current == start_date) {
          custom_arr.push(element);
        }
      });
      return custom_arr;
    },
    // Manage status
    manageStatus(main_status,status,is_clockedIn,is_clockedOut){
      let text = '';
      if (main_status == 'CIN' && status == 'IN' && is_clockedIn) {
        text = 'Clock On';
      } 
      else if (main_status == 'CIN' && status == 'IN' && !is_clockedIn) {
        text = 'In';
      } 
      else if (main_status == 'COUT' && status == 'OUT') {
        text = 'Clock Off';
      }
      else if (main_status == 'CIN' && status == 'BI') {
        text = 'Break Start';
      } 
      else if (main_status == 'CIN' && status == 'BS') {
        text = 'Break End';
      }
      else if (main_status == 'CIN' && status == 'OUT') {
        text = 'Out';
      }
      return text;
    },
    /** set avatar name */
    usernameList(firstname, lastname) {
      if (firstname && lastname) {
        let first = firstname.trim().charAt(0);
        let last = lastname.trim().charAt(0);
        let name = first.concat(last);
        return name.toUpperCase();
      }
    }, 
    // ===== Get User List =====
    async getusers() {
      this.$vs.loading({ color: "primary" });

      let url = "user/getOrganizationalUser?1=1";
      if (this.search) {
        url += '&search='+this.search;
      }
      if (this.office_id) {
        let office = this.office_id ? this.office_id : 'all';
        url += "&office="+office;
      }
      if (this.department_id) {
        let department = this.department_id ? this.department_id.toString() : 'all'
        url += "&department="+department;
      }
      return await this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.all_users = data;
          this.$vs.loading.close();
          return true;
        })
        .catch(e => {
          this.showError(e);
          return false;
        });
    }, 
    // Get user Activty Details
    async getUserActivityDetails(user_id = null,firstname='',lastname='',departmentname='',officename=''){
      // if (this.active_user_id && this.active_user_id == user_id) {
      //   this.clearArray();
      //   return
      // }else{
        this.active_user_id = user_id;
        this.active_user_name = firstname+' '+lastname;
        this.active_user_department = departmentname;
        this.active_user_office = officename;
        this.active_first_name = firstname;
        this.active_last_name = lastname;
     // }
      if (!user_id) {
        this.$vs.notify({
          text: 'User not found. please select user!',
          color: "danger",
          position: "top-right"
        });
      }
      this.$vs.loading({ color: "primary" });
      let input = {
        timeZone: this.timezone,
        date: moment.tz(this.current_date, this.timezone).format('DD/MM/YYYY'),
        user_id: user_id,
      };
      return await this.axios
        .post('timesheet/getUserDailyTimeSheetData',input)
        .then(response => {
          if (response.data && response.data.status == 200 && response.data.data) {
            let data = response.data.data;
            this.activity_data = data.inoutData;
            this.total_active_time = this.covertToTime(data.totalActiveTimeInMiliSeconds+ data.totalOutInMilliSeconds);
            this.total_break_time = this.covertToTime(data.totalBreakTimeInMiliSeconds);
            EventBus.$emit('showButton', true);
            let csvData = [];
            if (this.activity_data.length != 0) {
              let that = this;
              let main_arr = this.manageTimeArray(this.activity_data);
              main_arr.forEach(element => {          
                let new_obj = {
                  User: this.active_user_name,
                  Status: this.manageStatus(element.main_status,element.status,element.is_clockedIn,element.is_clockedOut),
                  Time: moment.tz(element.start_time, that.timezone).format('hh:mm a'),
                  Comment: element.comment
                }
                csvData.push(new_obj);
              });
              this.csvData = csvData;
            }else {
              this.csvData = [];
            }
            this.$vs.loading.close();
            return true;
          }
        })
        .catch(e => {
          this.showError(e);
          return false;
        });
    },
    clearArray(){
      this.activity_data = [];
      this.active_user_id = null;
      this.active_user_name = null;
      this.total_active_time = null;
      this.total_break_time = null;
      this.active_user_office = '';
      this.active_user_department = '';
      this.active_first_name = '';
      this.active_last_name = '';
      this.csvData = [];
      EventBus.$emit('showButton', false);
    },
    getCSVData(){
      let csvData = [];
      if (this.activity_data.length != 0) {
        let that = this;
        let main_arr = this.manageTimeArray(this.activity_data);
        main_arr.forEach(element => {          
          let new_obj = {
            User: this.active_user_name,
            Status: this.manageStatus(element.main_status,element.status,element.is_clockedIn,element.is_clockedOut),
            Time: moment.tz(element.start_time, that.timezone).format('h:mm a'),
            Comment: element.comment
          }
          csvData.push(new_obj);
        });
      }
      return csvData;
    },
     openTimesheetSlidebar(id,current_date){
      let data = {
        id: id,
        current_date: current_date,
        type: 'day',
        isUserTimeSheet:false,
      }
      EventBus.$emit('open_timesheet_sidebar', data);
    },
    generatePDF(){
    //  let data_arr = this.getCSVData();
  
      var doc = new jsPDF();
      autoTable(doc, { html: '#pdfHeader' })
      autoTable(doc, { html: '#dailypdf' })
      doc.save(this.active_user_name+"-activity-data.pdf")
    
    }
  },
   destroyed() {
    EventBus.$off('dayDailyTimeAcitivityPDF');
  },
};
</script>
<style>
.activity-collapse > .vs-collapse-item > .vs-collapse-item--header {
  padding: 0px !important;
}
.activity-collapse > .vs-collapse-item .open-item > .vs-collapse-item--content {
  max-height: 100% !important;
}
</style>